// extracted by mini-css-extract-plugin
export default {"container":"CardsBlock_container__Puii-"};